exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar-content {\n  color: #ffffff;\n  padding-top: 80px;\n  position: relative;\n  z-index: 5; }\n\nul {\n  margin: 0;\n  padding: 0; }\n  ul li {\n    list-style: none;\n    padding: 10px;\n    position: relative; }\n    ul li:focus {\n      outline: none; }\n    ul li i {\n      border: 1px solid #d5ae73;\n      border-radius: 50%;\n      color: #d5ae73;\n      cursor: pointer;\n      font-size: 30px;\n      height: 60px;\n      padding: 14px;\n      text-align: center;\n      width: 60px; }\n    ul li a.active i {\n      background-color: #d5ae73;\n      color: #ffffff;\n      font-size: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/ui/sidebar/sidebar.component.scss
// module id = ../../../../../src/app/ui/sidebar/sidebar.component.scss
// module chunks = main